/* Dreami X60 — front-end behaviour. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  /* ---- Reveal on scroll ---------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.dreame-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- FAQ accordion ------------------------------------- */
  function initFaq() {
    document.querySelectorAll('.dreame-faq__q').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.dreame-faq__item');
        var panel = item.querySelector('.dreame-faq__a');
        var open = item.classList.contains('is-open');
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function h() {
            if (item.classList.contains('is-open')) panel.style.height = 'auto';
            panel.removeEventListener('transitionend', h);
          });
        }
      });
    });
  }

  /* ---- Gallery (thumbnail -> main) ----------------------- */
  function initGallery() {
    document.querySelectorAll('[data-dreame-gallery]').forEach(function (gal) {
      var main = gal.querySelector('.dreame-gallery__main');
      gal.querySelectorAll('.dreame-gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (!full) return;
          main.innerHTML = '<img src="' + full + '" alt="" />';
          gal.querySelectorAll('.dreame-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  /* ---- Variant switching + price ------------------------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '£{{amount}}').replace('{{amount}}', v);
  }
  function initBuybox() {
    document.querySelectorAll('[data-dreame-buybox]').forEach(function (box) {
      var dataEl = box.querySelector('[data-dreame-variants]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var fmt = box.getAttribute('data-money-format') || '£{{amount}}';
      var idInput = box.querySelector('.dreame-variant-id');
      var priceNow = box.querySelector('[data-price-now]');
      var submit = box.querySelector('[data-buy-submit]');
      var barPrice = document.querySelector('[data-stickybar-price]');

      function selected() {
        var opts = [];
        box.querySelectorAll('[data-option-index]').forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) opts[+group.getAttribute('data-option-index')] = checked.value;
        });
        return opts;
      }
      function match(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return !opts[i] || o === opts[i]; });
        });
      }
      function update() {
        var v = match(selected());
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price, fmt);
        if (barPrice) barPrice.textContent = money(v.price, fmt);
        if (submit) {
          submit.disabled = !v.available;
          var span = submit.querySelector('span');
          if (span && !v.available) span.textContent = 'Sold out';
        }
      }
      box.querySelectorAll('.dreame-variant input').forEach(function (inp) {
        inp.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---- Sticky mobile buy bar ----------------------------- */
  function initStickybar() {
    var bar = document.querySelector('.dreame-stickybar');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor) return;
    var ticking = false;
    function evaluate() {
      ticking = false;
      var rect = anchor.getBoundingClientRect();
      // Show once the main buy button has scrolled above the viewport,
      // hide again near the very bottom of the page (footer/CTA area).
      var nearBottom = (window.innerHeight + window.scrollY) >= (document.body.scrollHeight - 120);
      if (rect.bottom < 0 && !nearBottom) bar.classList.add('is-visible');
      else bar.classList.remove('is-visible');
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(evaluate); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    evaluate();
    // Sticky bar button forwards click to the real add-to-cart
    var barBtn = bar.querySelector('[data-stickybar-add]');
    if (barBtn) {
      barBtn.addEventListener('click', function (e) {
        var realBtn = document.querySelector('[data-buy-submit]');
        if (realBtn) { e.preventDefault(); realBtn.click(); }
      });
    }
  }

  /* ---- Lazy video (below-fold): load + play only in view --- */
  function initLazyVideo() {
    var vids = document.querySelectorAll('video[data-dreame-video]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { rootMargin: '200px 0px', threshold: 0.1 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init() {
    initReveal();
    initFaq();
    initGallery();
    initBuybox();
    initStickybar();
    initLazyVideo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-init inside the Shopify theme editor when sections reload
  document.addEventListener('shopify:section:load', init);
})();
